import { DepositAccount } from '../../models/DepositAccount';
import { UseCase } from '../UseCase';
import { BalanceRepository } from '../../repositories/BalanceRepository';

export class GetDepositAccounts implements UseCase<GetDepositAccountsRequestDto, DepositAccount[]>{

    constructor(
        private balanceRepo: BalanceRepository
    ) { }
    
    execute(_: GetDepositAccountsRequestDto): Promise<DepositAccount[]> {
        return this.balanceRepo.getDepositAccounts();
    }
}

export class GetDepositAccountsRequestDto {
}